import {
  actions,
  getProductGroupsLookupsAsync,
  getProductGroupsDatatableAsync,
  createProductGroupAsync,
  editProductGroupAsync,
  getProductGroupByIdAsync,
  setProductsToProductGroupAsync,
  getProductGroupByIdWithProductsAsync,
} from './slices';

export const ProductGroupsActions = {
  ...actions,
  getProductGroupsLookupsAsync,
  getProductGroupsDatatableAsync,
  createProductGroupAsync,
  editProductGroupAsync,
  getProductGroupByIdAsync,
  setProductsToProductGroupAsync,
  getProductGroupByIdWithProductsAsync,
};
